import {observable, action} from 'mobx';
import {ComponentBaseController} from '@techsee/techsee-client-infra/lib/infra/ComponentBaseController';

export class ThankYouModalController extends ComponentBaseController {
    private static readonly MODAL_VISIBILITY_DURATION = 3000;
    @observable isVisible = false;
    timeoutId: ReturnType<typeof setTimeout> | null = null;

    constructor(private opts?: {dir?: string}) {
        super();
    }

    @action
    open() {
        this.isVisible = true;

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        this.timeoutId = setTimeout(
            action(() => {
                this.close();
            }),
            ThankYouModalController.MODAL_VISIBILITY_DURATION
        );
    }

    @action
    close() {
        if (!this.isVisible) {
            return;
        }
        this.isVisible = false;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }

        this.emit('CLOSED');
    }

    get dir() {
        return this.opts?.dir || 'ltr';
    }
}
